// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bek_a bhv_qn bhv_qo bhv_ua bhv_cy bhv_ty bhv_gm bhv_ka"};